import { TrackingEvent } from 'client/tracking/event';
import { TrackingConstant } from 'client/tracking/constant';
import { CommonMap } from 'client/tracking/maps/common';

const map = {
  caramel_cta: TrackingEvent.actionStart(
    TrackingConstant.ACTION_FILL_FORM,
    TrackingConstant.CHECKOUT_DEEPLINK_STARTED,
    {
      action_cause: TrackingConstant.ACTION_CAUSE_BUTTON_CLICK,
    }
  ),
};
export const CaramelTrackingMap = {
  ...CommonMap,
  ...map,
};
